import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectSecondaryFilter } from "../../features/secondaryFilter/secondaryFilterSlice";
import { setDataToUrl } from "../../utilities/urlResolver";
import { selectFilterData, selectFiltersLoaded } from '../../features/mainFilter/selectors';
import { selectSearch } from '../../features/mainFilter/searchSlice';

export default function useTrackUrlParams() {
  const userSearch = useSelector(state => state.userSearch);
  const search = useSelector(selectSearch);
  const lastChangedFilter = useSelector(state => state.app.lastChangedFilter);
  const showResults = useSelector(state => state.app.showResults);
  const mainFilter = useSelector(selectFilterData);
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const filtersReady = useSelector(selectFiltersLoaded);

  const {
    fromwhere,
    what,
    where,
    budget,
    who,
    when,
  } = mainFilter.searchEngine;
  /* const {
    when,
  } = search; */

  useEffect(() => {
    if (filtersReady) {
      if (lastChangedFilter || secondaryFilter?.lastChangedFilter) {
        setDataToUrl({
          mainFilter: {
            fromwhere,
            what,
            where,
            budget,
            when,
            who,
          },
          secondaryFilter: secondaryFilter.data,
          search: userSearch.selectedHotel,
        });
      }
    }

  }, [
    fromwhere,
    what,
    where,
    when,
    budget,
    who,
    userSearch.selectedHotel.hfDestinationId,
    secondaryFilter.data,
    filtersReady,
    showResults,
    userSearch.selectedHotel,
    lastChangedFilter,
    secondaryFilter?.lastChangedFilter,
  ]);
}
